import { useEffect, useState } from "react";
import Lenis from "lenis";
import TopBar from "@/components/TopBar";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import HowItWorks from "@/components/HowItWorks";
import Databases from "@/components/Databases";
import Pricing from "@/components/Pricing";
import Transparency from "@/components/Transparency";
import PrimaDopo from "@/components/PrimaDopo";
import Cases from "@/components/Cases";
import ResultsCounter from "@/components/ResultsCounter";
import WhyUs from "@/components/WhyUs";
import Team from "@/components/Team";
import FAQ from "@/components/FAQ";
import SeoText from "@/components/SeoText";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import OrderModal from "@/components/OrderModal";
import ChatWidget from "@/components/ChatWidget";
import CallFloat from "@/components/CallFloat";
import ExitIntent from "@/components/ExitIntent";
import { useLang } from "@/i18n";

export default function Landing() {
  const { t } = useLang();
  const [orderStep, setOrderStep] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    const onAnchor = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (a) {
        const el = document.querySelector(a.getAttribute("href"));
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -110 });
        }
      }
    };
    document.addEventListener("click", onAnchor);
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onAnchor);
      lenis.destroy();
    };
  }, []);

  return (
    <div data-testid="landing-page">
      <TopBar />
      <Header onCta={setOrderStep} />
      <Hero onCta={setOrderStep} />
      <Marquee />
      <HowItWorks onCta={setOrderStep} />
      <Databases onCta={setOrderStep} />
      <Pricing onCta={setOrderStep} />
      <Transparency />
      <PrimaDopo />
      <Cases />
      <ResultsCounter />
      <WhyUs />
      <Team />
      <FAQ />
      <SeoText />
      <ContactSection />
      <Footer />

      <button
        data-testid="sticky-mobile-cta"
        onClick={() => setOrderStep("visure")}
        className="btn-green lg:hidden fixed bottom-4 inset-x-4 z-40 rounded-full py-4 text-sm font-bold shadow-2xl"
      >
        {t("mobile.cta")} →
      </button>

      <OrderModal step={orderStep} onClose={() => setOrderStep(null)} />
      <ChatWidget />
      <CallFloat />
      <ExitIntent onCta={setOrderStep} />
    </div>
  );
}
